"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.TimerWrapper = exports.Interval = exports.TimeLeft = exports.CountdownBlock = exports.CountdownTitle = exports.CountdownWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _rebass = require("rebass");

var _Typography = require("../Typography");

var _types = _interopRequireDefault(require("./types"));

var CountdownWrapper = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var _ref$theme = _ref.theme,
      mediaQueries = _ref$theme.mediaQueries,
      space = _ref$theme.space;
  var style = {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    height: '24rem' // space.large * 10

  };
  return (0, _styledSystem.variant)({
    variants: {
      regular: _objectSpread(_objectSpread({}, style), {}, _defineProperty({
        justifyContent: 'space-evenly'
      }, mediaQueries.medium, {
        height: '32rem' // space.xlarge * 10

      })),
      light: _objectSpread(_objectSpread({}, style), {}, _defineProperty({
        justifyContent: 'space-between',
        padding: "".concat(space.xxlarge, " 0"),
        height: '30rem'
      }, mediaQueries.medium, {
        padding: 0,
        height: '12rem',
        flexDirection: 'row'
      })) // TODO: not finished work for 'fixed' variant
      // fixed: {
      //   ...style,
      //   position: 'fixed',
      //   bottom: '0',
      //   width: '100%',
      //   [mediaQueries.medium]: {
      //     width: '60%',
      //     flexDirection: 'row',
      //     height: 'auto',
      //   },
      // },

    }
  });
});
exports.CountdownWrapper = CountdownWrapper;
var CountdownTitle = (0, _styled.default)(_Typography.Body)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      mediaQueries = _ref2$theme.mediaQueries,
      variantType = _ref2.variantType;
  return _defineProperty({
    textTransform: 'uppercase',
    fontWeight: 'bold',
    paddingBottom: 'none'
  }, mediaQueries.medium, {
    fontSize: '3rem',
    paddingBottom: variantType === 'light' ? 0 : space.base
  });
});
exports.CountdownTitle = CountdownTitle;
var CountdownBlock = (0, _styled.default)('div')(function (_ref4) {
  var mediaQueries = _ref4.theme.mediaQueries,
      variantType = _ref4.variantType;
  return _defineProperty({
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%'
  }, mediaQueries.medium, {
    flexBasis: variantType === _types.default.light ? '50%' : 'auto'
  });
});
exports.CountdownBlock = CountdownBlock;
var TimeLeft = (0, _styled.default)(_Typography.Body)(function (_ref6) {
  var mediaQueries = _ref6.theme.mediaQueries,
      variantType = _ref6.variantType;
  return _defineProperty({
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 0,
    lineHeight: 1,
    fontSize: '3rem'
  }, mediaQueries.medium, {
    fontSize: variantType === _types.default.light ? '3rem' : '5rem'
  });
});
exports.TimeLeft = TimeLeft;
var Interval = (0, _styled.default)('div')(function () {
  return {
    fontWeight: 'bold',
    textAlign: 'center'
  };
});
exports.Interval = Interval;
var TimerWrapper = (0, _styled.default)('span')(function () {
  return {
    minWidth: '70px'
  };
});
exports.TimerWrapper = TimerWrapper;